import React from 'react';
import PropTypes from 'prop-types';
import authHelper from 'helpers/auth';
import compose from 'recompose/compose';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { deleteUserImpersonation } from 'store/actions/users/impersonation/deleteUserImpersonation';

class ImpersonationBar extends React.PureComponent {
    handleClick() {
        const {
            dispatchRequest,
        } = this.props;

        dispatchRequest({
            onSuccess: () => {
                document.location.href = `/users/${ authHelper.getUserId() }/show`;
            },
        });
    }

    render() {
        const impersonationBar = {
            padding: '1rem',
            cursor: 'pointer',
            textDecoration: 'none',
            backgroundColor: theme.palette.doveGray,
            color: theme.palette.white,
            fontSize: '14px',
        };

        const impersonationBarTitle = {
            fontWeight: 600,
            marginBottom: '5px',
            fontSize: '16px',
        };

        const { translate } = this.props;
        const userName = authHelper.getUserName();
        const companyName = authHelper.getCompanyName();

        let label = userName;

        if (companyName) {
            label = `${ userName } [${ companyName }]`;
        }

        return (
            <div
                style={ impersonationBar }
                onClick={ () => {
                    this.handleClick();
                } }
            >
                <div style={ impersonationBarTitle }>
                    { translate('impersonation.logged_in', { name: label }) }
                </div>
                { translate('impersonation.actions.log_out') }
            </div>
        );
    }
}

ImpersonationBar.propTypes = {
    dispatchRequest: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchRequest: (values) => {
            dispatch(deleteUserImpersonation(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(ImpersonationBar);



// WEBPACK FOOTER //
// ./src/components/layout/Layout/content/ImpersonationBar.js